// @ts-nocheck
import Link from "next/link";

import { VioAvatar } from "@/components/vio";

export default function Hero() {
  return (
    <>
<section className="hero" style={{display:"block",padding:0}}>
  <canvas aria-hidden="true" id="hc"></canvas>

  {/* Both columns get explicit, comparable widths (rather than one fixed and
      one unbounded 1fr) and the pair is capped + centred within the
      full-bleed hero — otherwise the right column stretches to fill all
      remaining viewport width on wide screens while the left stays a fixed
      600px, which reads as "left has way less room than right". */}
  <div style={{display:"flex",flexWrap:"nowrap",gap:"40px",maxWidth:"1380px",margin:"0 auto",padding:"110px 60px 72px",position:"relative",zIndex:2}}>

  <div className="hero-l" style={{justifyContent:"flex-start",flex:"1 1 620px",maxWidth:"640px",padding:0}}>
    <div className="h-ey">Contracts · Matters · Drafting · Privacy · Client portal — one suite</div>
    <h1 className="h-h1">
      <span className="hln">
        <span className="hw" style={{"animationDelay":".13s"}}>Legal,</span>{" "}
        <span className="hw" style={{"animationDelay":".23s"}}>Privacy</span>
      </span>{" "}
      <span className="hln">
        <span className="hw" style={{"animationDelay":".32s"}}>&</span>{" "}
        <span className="hw" style={{"animationDelay":".41s"}}>Matters</span>{" "}
        <span className="hw" style={{"animationDelay":".49s"}}>—</span>{" "}
        <span className="hw" style={{"animationDelay":".56s"}}>One</span>
      </span>{" "}
      <span className="hln"><em>
        <span className="hw" style={{"animationDelay":".64s"}}>AI</span>{" "}
        <span className="hw" style={{"animationDelay":".72s"}}>Suite</span>{" "}
        <span className="hw" style={{"animationDelay":".79s"}}>for</span>{" "}
        <span className="hw" id="sw" style={{"animationDelay":".86s"}}>the World</span>
      </em></span>
    </h1>
    <p className="h-sub" style={{marginTop:"18px"}}>One login covers contracts, matters and privacy — contract review and the full contract lifecycle, a case studio that reads the file, drafting from your voice, a client portal, and a privacy programme under your own country&apos;s law. Grounded in the governing law, never a guess at it.</p>
    <div className="h-acts" style={{marginTop:"20px"}}>
      <Link className="btn-p" data-mag="true" href="/scan"><span>Free Scanner</span></Link>
      <a className="btn-s" href="#story">See how it works</a>
    </div>
    <div className="h-trust" style={{marginTop:"12px"}}>
      <span className="h-trust-item"><span aria-hidden="true" className="h-trust-tick">✓</span>No credit card</span>
      <span aria-hidden="true" className="tsep">·</span>
      <span className="h-trust-item"><span aria-hidden="true" className="h-trust-tick">✓</span>Free scanner, no signup</span>
      <span aria-hidden="true" className="tsep">·</span>
      <span className="h-trust-item"><span aria-hidden="true" className="h-trust-tick">✓</span>Cancel anytime</span>
    </div>
  </div>

  <div className="hero-r-col" style={{justifyContent:"flex-start",flex:"1 1 620px",maxWidth:"660px",padding:0}}>
    <div className="h-engines-label" style={{margin:"0 0 16px",fontSize:"10px",letterSpacing:".18em",textTransform:"uppercase",color:"var(--o900)",fontWeight:700,display:"flex",alignItems:"center",gap:"10px"}}>
      <span aria-hidden="true" style={{width:"18px",height:"1px",background:"var(--cu)",display:"inline-block"}}></span>
      Two AI assistants · One platform
    </div>
    <div className="h-engines-block" style={{margin:"0",borderTop:"1px solid var(--b200)",borderBottom:"1px solid var(--b200)"}}>
      <Link className="h-engine-row" href="/features/vio-ask" style={{
        display:"grid",gridTemplateColumns:"minmax(120px, 26%) 1fr",alignItems:"center",
        gap:"22px",padding:"30px 0",borderBottom:"1px dashed var(--b200)",
        textDecoration:"none",
      }}>
        <div className="h-engine-name" style={{
          display:"flex",flexDirection:"column",alignItems:"flex-start",gap:"10px",
        }}>
          <VioAvatar size={40} />
          <span style={{
            fontFamily:"var(--font-fraunces), serif",fontSize:"clamp(36px,5vw,60px)",fontWeight:200,
            fontStyle:"italic",color:"var(--cu)",letterSpacing:"-.03em",lineHeight:1,
          }}>Vio<span style={{color:"var(--o900)"}}>.</span></span>
        </div>
        <div>
          <div style={{fontFamily:"var(--font-fraunces), serif",fontSize:"clamp(15px,1.6vw,19px)",fontWeight:300,color:"var(--o900)",letterSpacing:"-.01em",marginBottom:"4px"}}>
            Reads <em style={{color:"var(--cu)"}}>any one</em> contract.
          </div>
          <div style={{fontSize:"12.5px",color:"rgba(19,18,16,.55)",lineHeight:1.55}}>
            Ask. Draft. Redline. The AI copilot inside a document, with cited answers and tracked-change export.
            <span style={{display:"inline-block",marginLeft:"8px",color:"var(--cu)",letterSpacing:".02em"}}>Meet Vio →</span>
          </div>
        </div>
      </Link>

      <Link className="h-engine-row" href="/features/nexus-search" style={{
        display:"grid",gridTemplateColumns:"minmax(120px, 26%) 1fr",alignItems:"center",
        gap:"22px",padding:"30px 0",
        textDecoration:"none",
      }}>
        <div className="h-engine-name" style={{
          fontFamily:"var(--font-fraunces), serif",fontSize:"clamp(36px,5vw,60px)",fontWeight:200,
          fontStyle:"italic",color:"var(--cu)",letterSpacing:"-.03em",lineHeight:1,
        }}>Nexus<span style={{color:"var(--o900)"}}>.</span></div>
        <div>
          <div style={{fontFamily:"var(--font-fraunces), serif",fontSize:"clamp(15px,1.6vw,19px)",fontWeight:300,color:"var(--o900)",letterSpacing:"-.01em",marginBottom:"4px"}}>
            Thinks across <em style={{color:"var(--cu)"}}>all of them</em>.
          </div>
          <div style={{fontSize:"12.5px",color:"rgba(19,18,16,.55)",lineHeight:1.55}}>
            Search, rollups, clause-coverage maps, knowledge graphs, proactive insights — across every document you&apos;ve uploaded.
            <span style={{display:"inline-block",marginLeft:"8px",color:"var(--cu)",letterSpacing:".02em"}}>Meet Nexus →</span>
          </div>
        </div>
      </Link>
    </div>
    <div style={{marginTop:"36px",display:"flex",gap:"32px",flexWrap:"wrap"}}>
      <div>
        <div style={{fontFamily:"var(--font-fraunces), serif",fontSize:"clamp(24px,2.4vw,32px)",fontWeight:300,color:"var(--cu)",letterSpacing:"-.02em",lineHeight:1}}>3</div>
        <div style={{fontSize:"11px",color:"rgba(19,18,16,.55)",marginTop:"6px",letterSpacing:".04em",textTransform:"uppercase"}}>Modules · one login</div>
      </div>
      <div>
        {/* FEATURES.length in src/app/features/_data/features.ts (entries with no
            market tag) — 58 on 2026-09-18; the Platform and Intelligence menus
            carry the same number. */}
        <div style={{fontFamily:"var(--font-fraunces), serif",fontSize:"clamp(24px,2.4vw,32px)",fontWeight:300,color:"var(--cu)",letterSpacing:"-.02em",lineHeight:1}}>58</div>
        <div style={{fontSize:"11px",color:"rgba(19,18,16,.55)",marginTop:"6px",letterSpacing:".04em",textTransform:"uppercase"}}>Features, every status labelled</div>
      </div>
      <div>
        {/* 2026-10-08: was "9 official statute sources" — the adapters check
            LexVio's own jurisdiction notes before publication, and no answer
            a customer gets has passed through them yet. 14 = the global
            privacy packs (g-backend app/services/privacy_packs/registry.py
            PACK_MODULES minus the India-only in_dpdp). */}
        <div style={{fontFamily:"var(--font-fraunces), serif",fontSize:"clamp(24px,2.4vw,32px)",fontWeight:300,color:"var(--cu)",letterSpacing:"-.02em",lineHeight:1}}>14</div>
        <div style={{fontSize:"11px",color:"rgba(19,18,16,.55)",marginTop:"6px",letterSpacing:".04em",textTransform:"uppercase"}}>Privacy laws, one programme</div>
      </div>
    </div>

    <div style={{marginTop:"40px",paddingTop:"26px",borderTop:"1px solid var(--b200)"}}>
      <div style={{fontSize:"10px",letterSpacing:".14em",textTransform:"uppercase",color:"rgba(19,18,16,.5)",marginBottom:"12px"}}>
        Privacy &amp; Data Protection · under your own law
      </div>
      <p style={{fontSize:"13px",color:"rgba(19,18,16,.6)",lineHeight:1.7,maxWidth:"420px",margin:"0 0 16px"}}>
        One engine for the whole programme — applicability, data inventory, rights requests, breach clocks, retention, processors, impact assessments — under the law your organisation is subject to. Every law pack is marked drafted until counsel has checked it against the official text, and the product says so on screen. Not legal advice.
      </p>
      <div style={{display:"flex",flexWrap:"wrap",gap:"8px"}}>
        <span style={{fontSize:"11px",padding:"6px 11px",border:"1px solid var(--b200)",borderRadius:"3px",color:"var(--o900)"}}>EU GDPR · UK GDPR</span>
        <span style={{fontSize:"11px",padding:"6px 11px",border:"1px solid var(--b200)",borderRadius:"3px",color:"var(--o900)"}}>CCPA/CPRA · NY SHIELD · Delaware</span>
        <span style={{fontSize:"11px",padding:"6px 11px",border:"1px solid var(--b200)",borderRadius:"3px",color:"var(--o900)"}}>PIPEDA · Australia · New Zealand</span>
        <span style={{fontSize:"11px",padding:"6px 11px",border:"1px solid var(--b200)",borderRadius:"3px",color:"var(--o900)"}}>Singapore · Hong Kong · DIFC</span>
        <span style={{fontSize:"11px",padding:"6px 11px",border:"1px solid var(--b200)",borderRadius:"3px",color:"var(--o900)"}}>POPIA · Kenya · Nigeria</span>
      </div>
    </div>
  </div>

  </div>
</section>


    </>
  );
}
